import styled from 'styled-components'

const StyledPre = styled.pre`
  background-color: transparent;
  width: 100%;
  box-sizing: border-box;
  min-height: 40px;
  height: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  user-select: text;
  font-weight: 500;
  color: rgb(43, 43, 43);
  font-size: 14px;
  line-height: 16px;
  text-transform: none;
`
interface PreformattedTextProps {
  value?: string
  defaultValue?: string
}

const PreformattedText: React.FC<PreformattedTextProps> = ({ value, defaultValue = '' }) => {
  const content = value ?? defaultValue
  return <StyledPre>{content}</StyledPre>
}

export default PreformattedText
